import React, { Component } from 'react'
import {Link} from 'react-router-dom'
import './menu.css'

export class menu extends React.Component {
    constructor(props) {
        super(props) 
    this.state = {
        menu: true
    }        
    this.burger = this.burger.bind(this)
    }
    burger() {
    var hold = document.getElementById("menu-nav-div")
    if (this.state.menu) {
    hold.style.display = "block"    
    }  else {
    hold.style.display = "none"
    }     
    this.setState({
        menu: !this.state.menu
    })  
    }
    
    
    render() {
        return (
            <div id="menu-con">
<div id="burger-con" onClick={this.burger}>
<svg viewBox="0 0 100 80" width="40" height="40">
  <rect fill="#37447E" width="80" height="20"></rect>
  <rect fill="#37447E" y="30" width="80" height="20"></rect>
  <rect fill="#37447E" y="60" width="80" height="20"></rect>
</svg>   
</div>


<nav id="menu-nav-div" >
    <ul id="menu-nav-con">
        <li>
        <Link className="menu-link-1" to="/about">About</Link>
        </li>
        <li>
        <Link className="menu-link-1" to="/products">Products</Link>
        </li>
       <li>
        <Link className="menu-link-1" to="/contact">Contact</Link>
        </li>
    </ul>
</nav>

<Link className="link"to="/"> <h2 id="menu-title"> American Products Depot</h2></Link>

<Link  to="/contact"><button id="menu-btn">Book Video Demo</button>
</Link>

<div id="menu-svg-con">
<svg className="menu-svg-1" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.4121 14.4121L20 20" stroke="#2329D6" strokeLinecap="round"/>
<path fillRule="evenodd" clipRule="evenodd" d="M10 16C13.3137 16 16 13.3137 16 10C16 6.68629 13.3137 4 10 4C6.68629 4 4 6.68629 4 10C4 13.3137 6.68629 16 10 16Z" stroke="#2329D6"/>
</svg>

<svg className="menu-svg-1" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.5 19.5C5.5 19.5 9 18 10 17C11 16 8 16 8 11C8 6 12 6 12 6C12 6 16 6 16 11C16 16 13 16 14 17C15 18 18.5 19.5 18.5 19.5" stroke="#2329D6" strokeLinecap="round"/>
<path fillRule="evenodd" clipRule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#2329D6"/>
</svg>

<svg className="menu-svg-1" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M5.7103 5.99999H21.2921L19.8081 15H7.19428L5.7103 5.99999Z" stroke="#2329D6" strokeLinecap="round" strokeLinejoin="round"/>
<path fillRule="evenodd" clipRule="evenodd" d="M9 20C9.55228 20 10 19.5523 10 19C10 18.4477 9.55228 18 9 18C8.44772 18 8 18.4477 8 19C8 19.5523 8.44772 20 9 20Z" stroke="#2329D6"/>
<path fillRule="evenodd" clipRule="evenodd" d="M18 20C18.5523 20 19 19.5523 19 19C19 18.4477 18.5523 18 18 18C17.4477 18 17 18.4477 17 19C17 19.5523 17.4477 20 18 20Z" stroke="#2329D6"/>
<path d="M7 6H3" stroke="#2329D6" strokeLinecap="round"/>
</svg>
</div>


            </div>
        )
    }
}

export default menu
